import { render, staticRenderFns } from "./FgReqs.vue?vue&type=template&id=29405122&scoped=true&lang=html&"
import script from "./FgReqs.vue?vue&type=script&lang=js&"
export * from "./FgReqs.vue?vue&type=script&lang=js&"
import style0 from "./FgReqs.vue?vue&type=style&index=0&id=29405122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29405122",
  null
  
)

export default component.exports